


















































import Vue from 'vue'
import {BUY_CHESS, REFRESH_SHOP, TOGGLE_LOCKED} from '@/common/mutation-types'
import {Chess} from '@/common/types'

export default Vue.extend({
  name: 'Shop',
  computed: {
    locked(): boolean {
      return this.$store.state.gameInfo.locked
    },
    shop(): Chess[] {
      return this.$store.state.gameInfo.shop
    },
    gold(): number {
      return this.$store.state.gameInfo.gold
    },
  },
  methods: {
    buyChess(num: number) {
      this.$store.commit(BUY_CHESS, num)
    },
    refreshShop() {
      this.$store.commit(REFRESH_SHOP)
    },
    toggleLocked() {
      this.$store.commit(TOGGLE_LOCKED)
    },
  },
})
